import { FC } from 'react';
import { Box } from '@wix/design-system';
import SortMenu from '@components/Templates/SortMenu';
import TemplateCountDisplay from './TemplateCountDisplay';

interface Props {
  className?: string;
  templateCount?: number;
  hasSortMenu?: boolean;
}

const GalleryHeader: FC<Props> = ({
  className,
  templateCount,
  hasSortMenu = true,
}) => {
  return (
    <Box align="space-between" width="100%" className={className}>
      <TemplateCountDisplay templateCount={templateCount} />
      {hasSortMenu && (
        <Box>
          <SortMenu />
        </Box>
      )}
    </Box>
  );
};

export default GalleryHeader;
